import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  FileText,
  Bot,
  Share2,
  Gauge,
  Mail,
  PlugZap,
  Wrench,
  MessageSquare,
} from "lucide-react";

export const Route = createFileRoute("/admin/")({
  head: () => ({
    meta: [
      { title: "Admin dashboard · Simply Approved Mortgages" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminDashboard,
});

const TILES = [
  {
    to: "/admin/posts",
    title: "Blog",
    description: "Draft, publish, and schedule investor articles for the public blog.",
    icon: FileText,
  },
  {
    to: "/admin/blog-agent",
    title: "AI blog agent",
    description: "Automated topic research, outlining, drafting, and SEO review.",
    icon: Bot,
  },
  {
    to: "/admin/chatbot",
    title: "AI chat bot",
    description: "Knowledge base, conversation history, training, and live transfer.",
    icon: MessageSquare,
  },
  {
    to: "/admin/social",
    title: "Social media",
    description: "Compose, schedule, and measure cross-channel investor content.",
    icon: Share2,
  },
  {
    to: "/admin/seo",
    title: "SEO operating system",
    description: "Rank tracking, CTR opportunities, internal links, and performance.",
    icon: Gauge,
  },
  {
    to: "/admin/leads",
    title: "Leads",
    description: "Submitted applications and partial leads across every loan product.",
    icon: Mail,
  },
  {
    to: "/admin/integrations-health",
    title: "Integrations",
    description: "Live status of CRM, Zapier, and email delivery.",
    icon: PlugZap,
  },
  {
    to: "/admin/tools",
    title: "Loan officer tools",
    description: "STR analyzer, lending guidelines library, and document checklists.",
    icon: Wrench,
  },
] as const;

function AdminDashboard() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-black tracking-tight">Admin dashboard</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Blog, AI chat bot, social, SEO, and loan officer tools for Simply Approved Mortgages.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to} className="group">
            <Card className="h-full transition group-hover:border-brand/60 group-hover:shadow-md">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="rounded-lg bg-brand/10 p-2 text-brand">
                    <t.icon className="h-5 w-5" />
                  </div>
                  <CardTitle className="text-base">{t.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>{t.description}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
